export const getAdditionalProducts = () => {
  return JSON.parse(localStorage.getItem('additionalProducts') ?? '[]');
};

export const isProductAdded = (deviceId: number, colorId: number) => {
  const currentAdditionalProducts = getAdditionalProducts();
  const existingDevice = currentAdditionalProducts.find((item: any) => item.id === deviceId && item.colorId === colorId);

  return Boolean(existingDevice);
};

interface Device {
  id: number;
  colorId: number;
  itemCount: number;
}

export const addProduct = (device: Device) => {
  const currentAdditionalProducts = getAdditionalProducts();
  const newAdditionalProducts = [...currentAdditionalProducts, device];
  localStorage.setItem('additionalProducts', JSON.stringify(newAdditionalProducts));
};

export const removeProduct = (deviceId: number, colorId: number) => {
  const currentAdditionalProducts = getAdditionalProducts();
  const newAdditionalProducts = currentAdditionalProducts.filter((item: any) => !(item.id === deviceId && item.colorId === colorId));
  localStorage.setItem('additionalProducts', JSON.stringify(newAdditionalProducts));
};

export const clearAdditionalProducts = () => {
  localStorage.removeItem('additionalProducts');
  localStorage.removeItem("insurance");
};

